import m, { useMemo as s } from "react";
import { useTranslation as i } from "react-i18next";
import { Gender as t } from "../../../../../../common/shared/gender.js";
import { Selector as f } from "../Selector/Selector.js";
function b(o) {
  const {
    value: r,
    onChange: l
  } = o, {
    t: e
  } = i(), a = [
    {
      value: t.MALE,
      label: e("gender.male")
    },
    {
      value: t.FEMALE,
      label: e("gender.female")
    },
    {
      value: t.OTHER,
      label: e("gender.other")
    },
    {
      value: t.NA,
      label: e("gender.na")
    }
  ], u = s(() => a.find((n) => n.value === r), [r]), c = (n, d) => {
    l == null || l(n.value, d);
  };
  return /* @__PURE__ */ m.createElement(
    f,
    {
      ...o,
      testId: "gender-selector",
      options: a,
      value: u,
      onChange: c
    }
  );
}
export {
  b as GenderSelector
};
//# sourceMappingURL=GenderSelector.js.map
